import {
    checkLink,
    countWord,
    countTagsInString,
    getTagsInnerText,
    TCheckLink,
    TNumberOfKeyworks,
} from "../stringHelper";
import { countKeyword } from "../keywordsHelper";

export type TDocMetrics = {
    numberOfWords: number;
    numberOfH2: number;
    invalidH2: boolean;
    numberOfInvalidH2: number;
    numberOfH3: number;
    invalidH3: boolean;
    numberOfInvalidH3: number;
    numberOfBold: number;
    invalidBold: boolean;
    numberOfInvalidBold: number;
    numberOfItalic: number;
    invalidItalic: boolean;
    numberOfInvalidItalic: number;
    numberOfUnorderedList: number;
    invalidUnorderedList: boolean;
    numberOfInvalidUnorderedList: number;
    numberOfOrderedList: number;
    invalidOrderedList: boolean;
    numberOfInvalidOrderedList: number;
    keywords: TNumberOfKeyworks;
    links: TCheckLink;
};

export const handleData = (data: string, entity: any) => {
    const H2InData = countTagsInString("h2", data);
    const H3InData = countTagsInString("h3", data);
    const strongInData = countTagsInString("strong", data);
    const OlInData = countTagsInString("ol", data);
    const UlInData = countTagsInString("ul", data);
    const IInData = countTagsInString("i", data);

    return {
        headers: getTagsInnerText("h2, h3", data),
        h2: getTagsInnerText("h2", data),
        numberOfH2: H2InData.noEmpty,
        invalidH2: H2InData.empty > 0,
        numberOfInvalidH2: H2InData.empty,
        h3: getTagsInnerText("h3", data),
        numberOfH3: H3InData.noEmpty,
        invalidH3: H3InData.empty > 0,
        numberOfInvalidH3: H3InData.empty,
        numberOfBold: strongInData.noEmpty,
        invalidBold: strongInData.empty > 0,
        numberOfInvalidBold: strongInData.noEmpty,
        numberOfItalic: IInData.noEmpty,
        invalidItalic: IInData.empty > 0,
        numberOfInvalidItalic: IInData.noEmpty,
        numberOfUnorderedList: UlInData.noEmpty,
        invalidUnorderedList: UlInData.empty > 0,
        numberOfInvalidUnorderedList: UlInData.noEmpty,
        numberOfOrderedList: OlInData.noEmpty,
        invalidOrderedList: OlInData.empty > 0,
        numberOfInvalidOrderedList: OlInData.noEmpty,
        numberOfWords: countWord(data),
        keywords: countKeyword(entity?.keywords, data),
        links: checkLink(data, entity?.links),
    };
};
